module.exports = __webpack_public_path__ + "img/apple.34f67c17.svg";